import styled from "styled-components"
import { WrapPopupEdit } from "../index.style"

const WrapPopupEditCMND = styled(WrapPopupEdit)`
    
`

export {
    WrapPopupEditCMND
}